'use client';

import { MetaDefault } from '../../../../../components/typography';
import type { CardRenderContext } from '../../tool-config-types';
import { InlineExecutionToolCard } from '../shared/inline-execution-tool-card';
import { getHITLArtifactHeaderActions } from '../shared/hitl-artifact-header-actions';
import { toPrettyText } from '../shared/network-tool-card-utils';

export function renderBusinessContextCard(ctx: CardRenderContext) {
  const isRunning =
    ctx.toolCallData.status === 'started' ||
    ctx.toolCallData.status === 'in-progress';
  const outputText = toPrettyText(ctx.toolCallData.output);

  if (
    !isRunning &&
    !outputText &&
    !ctx.toolCallData.error &&
    ctx.toolCallData.status === 'completed'
  ) {
    return null;
  }

  return (
    <InlineExecutionToolCard
      title={isRunning ? ctx.labelPresent : ctx.labelPast}
      status={ctx.toolCallData.status}
      error={ctx.toolCallData.error}
      headerActions={getHITLArtifactHeaderActions(ctx)}
      defaultExpanded={false}
      autoCollapseWhenComplete={ctx.autoCollapseWhenComplete}
      forceExpanded={ctx.forceExpanded}
    >
      {outputText ? (
        <MetaDefault color="fg.muted" whiteSpace="pre-wrap">
          {outputText}
        </MetaDefault>
      ) : null}
    </InlineExecutionToolCard>
  );
}
